module.exports = __webpack_public_path__ + "static/media/pocket-kit-puff.99e15c4a.png";